/**
 * RoundnessControl — the „Rundung" slider of the morph pages: 0 % = the sharp base form, 100 % = sphere.
 * null = each shape keeps its own preset roundness; „Preset" goes back to that.
 */

import React from 'react';

export const RoundnessControl: React.FC<{
    /** Override in 0–1, or null = preset. */
    value: number | null;
    /** What is shown while there is no override. */
    presetValue: number;
    onChange: (value: number | null) => void;
}> = ({ value, presetValue, onChange }) => {
    const shown = value ?? presetValue;
    return (
        <div style={box} title="0 % = scharfe Grundform, 100 % = Kugel">
            <span style={{ color: '#94a3b8' }}>Rundung</span>
            <input type="range" min={0} max={100} step={1} value={Math.round(shown * 100)}
                onChange={e => onChange(Number(e.target.value) / 100)} style={{ width: '140px', accentColor: '#a78bfa' }} />
            <span style={{ minWidth: '40px', textAlign: 'right' }}>{Math.round(shown * 100)} %</span>
            {value !== null && (
                <button onClick={() => onChange(null)} style={reset} title="Zurück zur Rundung der jeweiligen Form">Preset</button>
            )}
        </div>
    );
};

const box: React.CSSProperties = {
    display: 'flex', alignItems: 'center', gap: '10px', height: '48px', padding: '0 16px', borderRadius: '24px',
    background: 'rgba(15,23,42,0.85)', border: '1px solid rgba(99,102,241,0.4)', color: '#a78bfa',
    fontFamily: 'monospace', fontSize: '13px', backdropFilter: 'blur(8px)',
};

const reset: React.CSSProperties = {
    background: 'transparent', border: '1px solid rgba(99,102,241,0.4)', borderRadius: '12px',
    color: '#a78bfa', fontFamily: 'monospace', fontSize: '11px', padding: '3px 8px', cursor: 'pointer',
};
